import { render, staticRenderFns } from "./sortAndAttribute.vue?vue&type=template&id=18c54d14&scoped=true"
import script from "./sortAndAttribute.vue?vue&type=script&lang=js"
export * from "./sortAndAttribute.vue?vue&type=script&lang=js"
import style0 from "./sortAndAttribute.vue?vue&type=style&index=0&id=18c54d14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c54d14",
  null
  
)

export default component.exports